import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController } from '@ionic/angular/lazy';
import { StorageService } from 'src/app/services/storage.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-order-fulfillment-options',
    templateUrl: './order-fulfillment-options.component.html',
    styleUrls: ['./order-fulfillment-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderFulfillmentOptionsComponent implements OnInit {

    @Input() order_fulfillment_page = null;
    printer_paper_sizes = [];

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        private storageService: StorageService,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {


        this.storageService.get("printer_paper_sizes").then((printer_paper_sizes) => {
            if(printer_paper_sizes) {
                this.printer_paper_sizes = printer_paper_sizes;
            }
        });

    }

    printPackingSlip() {
        this.order_fulfillment_page.printPackingSlip();
        this.dismiss();
    }

    printDeliveryNote() {
        this.order_fulfillment_page.printDeliveryNote();
        this.dismiss();
    }

    printCollectionNote() {
        this.order_fulfillment_page.printCollectionNote();
        this.dismiss();
    }

    presentOrderFulfillmentEditModal() {
        this.order_fulfillment_page.presentOrderFulfillmentEditModal();
        this.dismiss();
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

}
